module.exports = __webpack_public_path__ + "media/images/ach_checking-55060045cbc3f1e52059320685752917.svg";